import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import { CogNeedTextField } from '@cogneed/react-utils';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Fade,
  FormControl, FormControlLabel, MenuItem, RadioGroup, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Operators } from '../../../data';
import useFreeResiliationFormulaContext from '../../Contexts/FreeResiliationFormulaContext/useFreeResiliationFormulaContext';
import CogNeedRadio from '../../../../../../CogNeedRadio';

const SECTION_KEY = 'contract';

export default function ContractSection() {
  const { t } = useTranslation('wysiwyg');

  const {
    state, updateState, setExpanded, expanded, completedSteps: { contract: isCompleted },
  } = useFreeResiliationFormulaContext();

  function setContractType(value: string) {
    if (value === 'mobile') {
      updateState((prev) => ({
        ...prev, contractType: 'mobile', operator: undefined, newOffer: undefined,
      }));
    } else {
      updateState((prev) => ({
        ...prev, contractType: 'box', operator: undefined, newOffer: undefined,
      }));
    }
  }

  function setContractOperator(value: string) {
    updateState((prev) => ({ ...prev, operator: value }));
  }
  return (
    <Accordion
      expanded={expanded === SECTION_KEY}
      onChange={() => { setExpanded(expanded === SECTION_KEY ? null : SECTION_KEY); }}
      className="section"
      elevation={0}
      TransitionProps={{ unmountOnExit: true }}
    >
      <AccordionSummary expandIcon={(!isCompleted || expanded === SECTION_KEY) ? <ExpandMoreIcon /> : <CheckCircleOutlineIcon className="checked" />}>
        {t('resiliation-fee.contract-section.title')}
      </AccordionSummary>
      <AccordionDetails>
        <FormControl>
          <Typography variant="h4">
            {t('resiliation-fee.contract-section.device.title')}
          </Typography>
          <RadioGroup
            onChange={(event) => {
              setContractType(event.target.value);
            }}
            className="radio"
            // eslint-disable-next-line no-nested-ternary
            defaultValue={state.contractType ?? ''}
          >
            <FormControlLabel value="mobile" control={<CogNeedRadio />} label={t('resiliation-fee.contract-section.device.mobile')} />
            <FormControlLabel value="box" control={<CogNeedRadio />} label={t('resiliation-fee.contract-section.device.box')} />
          </RadioGroup>
        </FormControl>
        <Fade in={state.contractType === 'box'} mountOnEnter unmountOnExit>
          <FormControl>
            <Typography variant="h4">
              {t('resiliation-fee.contract-section.operator.title')}
            </Typography>
            <CogNeedTextField
              select
              onChange={(e) => { setContractOperator(e.target.value); }}
              defaultValue={state.operator ?? ''}
              sx={{ width: 220 }}
              SelectProps={{
                MenuProps: {
                  anchorOrigin: { vertical: 'bottom', horizontal: 2 },
                  transformOrigin: { vertical: -6, horizontal: 2 },
                },
                displayEmpty: true,
                renderValue(value): React.ReactNode {
                  if (value !== '') {
                    // eslint-disable-next-line react/jsx-no-useless-fragment
                    return <>{value}</>;
                  }
                  return t('resiliation-fee.contract-section.operator.placeholder');
                },
              }}
            >
              {Operators.map((value) => (
                <MenuItem key={value.name} value={value.name}>
                  {value.name}
                </MenuItem>
              ))}
            </CogNeedTextField>
          </FormControl>
        </Fade>
      </AccordionDetails>
    </Accordion>
  );
}
